export default class MessageBoxModel {
    caption: string = "";
    message: Array<string> = [];
    callbackId: string = "";
    btnYes : boolean = true;
    btnNo : boolean = true;

    btnYesText : string = "Yes";
    btnNoText : string = "No";

    defaultNo : boolean = true;
    defaultYes : boolean = false;

    // Optional - when dropdownOptions is non-empty, MessageBoxV2 renders a required "reason" dropdown
    // (label from dropdownLabel) and passes the selected value as the payload of the
    // "message-box-<callbackId>" emitter event (undefined when no dropdown was configured, so existing
    // no-argument listeners are unaffected). Selecting dropdownOtherValue reveals a required free-text
    // box; the value ultimately passed is that typed text rather than dropdownOtherValue itself.
    dropdownOptions: Array<string> = [];
    dropdownLabel: string = "Reason";
    dropdownOtherValue: string = "Other";
}